function setHeaderBottomPosition() {
    const siteHeader = document.querySelector('.site-header');
    if (!siteHeader) {
        return;
    }
    const headerRect = siteHeader.getBoundingClientRect();
    const headerBottom = headerRect.bottom;
    const headerTop = headerRect.top;


    document.body.style.setProperty('--header-bottom-position', `${headerBottom}px`);
    document.body.style.setProperty('--header-top-position', `${headerTop}px`);
}
// window.addEventListener('resize', setHeaderBottomPosition);



function initStickyHeader() {

    const siteHeader = document.querySelector('.site-header');

    const wrapper = siteHeader.closest('.site-header__wrapper');

    if (siteHeader && wrapper) {
        let headerOffset = siteHeader.offsetTop;
        let headerHeight = siteHeader.offsetHeight;

        const handleScroll = () => {
            if (window.scrollY > headerOffset) {
                siteHeader.classList.add('is-sticky');
                wrapper.style.marginBottom = `${headerHeight}px`;
            } else {
                siteHeader.classList.remove('is-sticky');
                wrapper.style.marginBottom = '';
            }
            // setHeaderBottomPosition();
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', () => {
            headerOffset = siteHeader.offsetTop;
            headerHeight = siteHeader.offsetHeight;
        });
    }
}


document.addEventListener("DOMContentLoaded", e => {
    initStickyHeader();
    // const initSticky = () => {
    //     initStickyHeader();
    //     window.removeEventListener('scroll', initSticky);
    // };
    // window.addEventListener('scroll', initSticky, { passive: true });
    // setTimeout(() => {
    //     setHeaderBottomPosition();
    // }, 200);

    const catalogButtons = document.querySelectorAll('.catalog-button');
    const mmw = document.querySelector('.mega-menu__wrapper');

    if (catalogButtons.length > 0) {
        catalogButtons.forEach((catalogButton) => catalogButton.addEventListener('click', showHiddenMegaMenu));
    }
    // Закриття по натисканню Escape
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('mega-active')) {
            showHiddenMegaMenu();
        }
    });

    if (mmw) {
        mmw.addEventListener('click', (e) => e.target === mmw ? showHiddenMegaMenu() : false);
    }

    function showHiddenMegaMenu() {
        setHeaderBottomPosition();
        document.body.classList.toggle('mega-active');

    }

    const mobileList = document?.querySelector('.mobile-list');

    const hasItems = mobileList?.querySelectorAll('.menu-item-has-children');

    hasItems?.forEach((liHasSubmenu) => {
        liHasSubmenu.addEventListener('click', (e) => {
            console.info(e.target);
            if (e.target === liHasSubmenu || e.target.classList.contains('sub-menu__head') || e.target.classList.contains('sub-menu__back')) {
                liHasSubmenu.classList.toggle('active');
            }
        });
    })

});
